import { render, staticRenderFns } from "./EzMultipleImageUpload.vue?vue&type=template&id=ba0f267a&scoped=true&"
import script from "./EzMultipleImageUpload.vue?vue&type=script&lang=js&"
export * from "./EzMultipleImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./EzMultipleImageUpload.vue?vue&type=style&index=0&id=ba0f267a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0f267a",
  null
  
)

export default component.exports